module.exports = __webpack_public_path__ + "static/media/target-logo.f6be047c.png";